module.exports = __webpack_public_path__ + "static/media/kertesz.8b2ab37b.jpg";